import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled } from '@zenbusiness/zui/styles';

const BoxContentStyle = ({ theme }) => ({
  padding: '16px 24px',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '22px'
});

const DialogContentStyle = () => ({
  padding: '60px 0 50px 0'
});

const FormControlLabelStyle = ({ theme }) => ({
  padding: '21px 0px',
  width: 'fit-content',
  [theme.breakpoints.up('sm')]: {
    padding: '16px 0px'
  }
});

const SharedAssetStyle = () => ({
  width: '100%'
});

const ImageWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 5'
  }
});

const ContentWrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '6 / 13'
  }
});

export const BoxContentStyled = styled(Box)(BoxContentStyle);
export const FormControlLabelStyled = styled(FormControlLabel)(FormControlLabelStyle);
export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const SharedAssetStyled = styled(SharedAsset)(SharedAssetStyle);
export const ImageWrapper = styled(Box)(ImageWrapperStyle);
export const ContentWrapper = styled(Box)(ContentWrapperStyle);
